/* eslint-disable react/jsx-props-no-spreading */
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Input } from 'antd';
import React from 'react';

function SearchInput({ ...prod }) {
  return (
    <div>
      <Input {...prod} prefix={<FontAwesomeIcon icon={faSearch} />} />
    </div>
  );
}

export default SearchInput;
